import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core'
import { Parking, ParkingStatus, Prospect } from '@parkupp/core'
import { firstValueFrom } from 'rxjs'
import { ParkingService } from 'src/app/services/parking.service'
import { ProspectingService } from 'src/app/services/prospecting.service'

declare const google: any

@Component({
    selector: 'app-prospecting-nav',
    templateUrl: './prospecting-nav.component.html',
    styleUrls: ['./prospecting-nav.component.scss'],
})
export class ProspectingNavComponent implements OnInit {
    showNewCompany = false
    saving = false
    newCompanyMessage = ''
    newCompanyError = ''
    newCompany: Partial<Prospect> = {}

    @ViewChild('addressInput') addressInputRef: ElementRef<HTMLInputElement>
    private autocomplete: any = null
    private parkings: Parking[] = []

    constructor(private prospecting: ProspectingService, private parkingService: ParkingService, private ngZone: NgZone) {}

    async ngOnInit(): Promise<void> {
        try {
            const all = await firstValueFrom(this.parkingService.listAll())
            this.parkings = all.filter((p) => p.parkingStatus === ParkingStatus.PUBLISHED)
        } catch {}
    }

    toggleNewCompany(): void {
        this.showNewCompany = !this.showNewCompany
        if (this.showNewCompany) {
            this.newCompany = {}
            this.newCompanyMessage = ''
            this.newCompanyError = ''
            setTimeout(() => this.initAutocomplete())
        } else {
            this.autocomplete = null
        }
    }

    private initAutocomplete(): void {
        if (!this.addressInputRef?.nativeElement || typeof google === 'undefined') return

        this.autocomplete = new google.maps.places.Autocomplete(this.addressInputRef.nativeElement, {
            types: ['address'],
            componentRestrictions: { country: 'za' },
        })

        this.autocomplete.addListener('place_changed', () => {
            this.ngZone.run(() => {
                const place = this.autocomplete.getPlace()
                if (!place?.geometry) return

                this.newCompany.fullAddress = place.formatted_address || place.name
                this.newCompany.latitude = place.geometry.location.lat()
                this.newCompany.longitude = place.geometry.location.lng()
            })
        })
    }

    async saveNewCompany(): Promise<void> {
        if (!this.newCompany.name?.trim()) return
        this.saving = true
        this.newCompanyMessage = ''
        this.newCompanyError = ''
        try {
            if (this.newCompany.latitude && this.newCompany.longitude) {
                this.newCompany.nearestParkings = this.prospecting.computeNearestParkings(
                    this.newCompany.latitude,
                    this.newCompany.longitude,
                    this.parkings
                )
            }
            await this.prospecting.createProspect(this.newCompany)
            this.newCompanyMessage = `"${this.newCompany.name}" created. Refresh the page to see it.`
            this.newCompany = {}
        } catch (e: any) {
            this.newCompanyError = e?.message || 'Failed to create company'
        } finally {
            this.saving = false
        }
    }
}
